import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import useFetch from '../../../hooks/useFetch';
import { fetchStoreRotation } from '../../../api/store';

const StoreBar = () => {
    const { data: storeRotation } = useFetch(fetchStoreRotation, null);
    const [timeLeft, setTimeLeft] = useState('');

    useEffect(() => {
        if (!storeRotation?.endTime) return;

        const tick = () => {
            const remaining = new Date(storeRotation.endTime).getTime() - Date.now();
            if (remaining <= 0) {
                setTimeLeft('Refreshing...');
                return;
            }
            const hrs = Math.floor(remaining / 3_600_000);
            const mins = Math.floor((remaining % 3_600_000) / 60_000);
            setTimeLeft(`${hrs}h ${mins}m`);
        };

        tick();
        const interval = setInterval(tick, 60_000);
        return () => clearInterval(interval);
    }, [storeRotation?.endTime]);

    if (!storeRotation?.endTime) return null;

    return (
        <div className="store-bar">
            <span className="store-timer">
                Store refreshes in <strong>{timeLeft}</strong>
            </span>
            <Link to="/packs/buy" className="store-link">
                Visit Store &rarr;
            </Link>
        </div>
    );
};

export default StoreBar;
